var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('iframe',{directives:[{name:"resize",rawName:"v-resize",value:({ log: false }),expression:"{ log: false }"}],staticClass:"embed-web",attrs:{"frameborder":"0","src":'/docs/docs'}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }